import React from "react";
import { Box, Heading, Status, Stack, Card } from "@origin-digital/ods-core";
import {
  PopularArticlesSkeleton,
  PopularArticles,
} from "../../../../components/PopularArticles";
import { ISubLinkDto } from "../../../../contract";
import styled from "styled-components";

interface PopularArticlesSectionProps {
  isLoading: boolean;
  popularArticles: ISubLinkDto[]; // Replace 'any' with the actual type of your articles
}

const RecommendedStatus = styled(Status)`
  position: absolute;
  top: -12px;
  z-index: 1;
`;

const StyledRecommendedArticleBox = styled(Card)`
  box-sizing: border-box;
  z-index: 1;
  position: relative;
  ${({ theme }) => theme.breakpoints.down("md")} {
    padding: 16px;
    padding-top: 32px;
  }
`;

export const PopularArticlesSection: React.FC<PopularArticlesSectionProps> = ({
  popularArticles,
  isLoading,
}) => {
  if (popularArticles.length === 0 && !isLoading) {
    return null;
  }
  return (
    <Box
      data-id="popular-articles-section"
      marginX={{ xs: "medium", sm: "none" }}
      height="full"
    >
      <StyledRecommendedArticleBox
        borderRadius="medium"
        blur="medium"
        backgroundColor="cardBackgroundSecondary"
        height="full"
      >
        {!isLoading && (
          <RecommendedStatus backgroundWeight="strong" tone="info">
            Recommended
          </RecommendedStatus>
        )}
        <Box marginBottom="xxsmall">
          <Heading component="h2" variant="h4">
            Popular articles
          </Heading>
        </Box>
        {isLoading ? (
          <PopularArticlesSkeleton />
        ) : (
          <PopularArticles popularArticles={popularArticles} />
        )}
      </StyledRecommendedArticleBox>
    </Box>
  );
};
